module.exports = __webpack_public_path__ + "img/answer2.00ad18ae.jpg";